<template>
  <div class="paymentLinkGeneratorDashboard">
    <vue-scroll :ops="ops">
      <div class="paymentLinkGeneratorDashboard__header">
        <div class="paymentLinkGeneratorDashboard__title">Payment link (cc hold) generator</div>
      </div>
      <div class="paymentLinkGenerator__items">
        <div class="paymentLinkGenerator__row">
          <div class="paymentLinkGenerator__row__title">Product name</div>
          <textarea v-model="productName" />
        </div>
        <div class="paymentLinkGenerator__row">
          <div class="paymentLinkGenerator__row__title">Price</div>
          <input
            class="paymentLinkGenerator__row__numeric-field"
            type="number"
            v-model="price"
            autocomplete="off"
          />
        </div>
        <div class="paymentLinkGenerator__row">
          <div class="paymentLinkGenerator__row__title">Name</div>
          <input
            class="paymentLinkGenerator__row__customer-field"
            v-model="customerName"
            autocomplete="off"
          />
        </div>
        <div class="paymentLinkGenerator__row">
          <div class="paymentLinkGenerator__row__title">Email</div>
          <input
            class="paymentLinkGenerator__row__customer-field"
            v-model="customerEmail"
            type="email"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="paymentLinkGenerator__row">
        <div class="paymentLinkGeneratorDashboard__button bottom" @click="generatePaymentLink('FLYFlights')">
          <span class="text">Stripe FLYFlights</span>
        </div>
        <div class="paymentLinkGeneratorDashboard__button bottom" @click="generatePaymentLink('FLYICorp')">
          <span class="text">Stripe FLYICorp</span>
        </div>
        <div class="paymentLinkGeneratorDashboard__button bottom" @click="generatePaymentLink('Square')">
          <span class="text">Square</span>
        </div>
      </div>
      <div class="paymentLinkGenerator__row result">
        <textarea v-model="paymentLink" />
      </div>
      <div>
        <div class="paymentLinkGeneratorDashboard__button" @click="copy(paymentLink)">
          <span class="text">Copy</span>
        </div>
        <div class="paymentLinkGeneratorDashboard__button" @click="clear">
          <span class="text">Clear</span>
        </div>
      </div>
      <div class="bookingDashboard bookingDashboard--list">
        <div class="bookingDashboard__table">
        <div class="bookingDashboard__table-header">
          <div class="bookingDashboard__table-cell">Created On</div>
          <div class="bookingDashboard__table-cell">Description</div>
          <div class="bookingDashboard__table-cell">Amount</div>
          <div class="bookingDashboard__table-cell"></div>
          <div class="bookingDashboard__table-cell"></div>
        </div>
        <div class="bookingDashboard__table-body">
            <div
              class="bookingDashboard__table-row"
              v-for="item of uncapturedPayments"
              :key="item.id"
            >
              <div class="bookingDashboard__table-cell aircraftNumber">{{item.createdOn}}</div>
              <div class="bookingDashboard__table-cell aircraftModel">{{item.description}}</div>
              <div class="bookingDashboard__table-cell aircraftType">${{item.amount}}</div>
              <div class="bookingDashboard__table-cell aircraftType">
                <div class="paymentLinkGeneratorDashboard__button" @click="capturePaymentClick(item.id)">
                  <span class="text">Capture</span>
                </div>
              </div>
              <div class="bookingDashboard__table-cell aircraftType">
                <div class="paymentLinkGeneratorDashboard__button" @click="cancelPaymentClick(item.id)">
                  <span class="text">Cancel</span>
                </div>
              </div>
            </div>
        </div>
        </div>
      </div>
    </vue-scroll>
      <InfoPopup/>
      <QuestionPopup
        :name="'QuestionPopupCancel'"
        :title="'The payment will be canceled.'"
        :text="'Are you sure?'"
        @remove="cancel"
      />
      <QuestionPopup
        :name="'QuestionPopupCapture'"
        :title="'The payment will be captured.'"
        :text="'Are you sure?'"
        @remove="capture"
      />
  </div>
</template>

<script>
import moment from 'moment'
import './PaymentLinkGenerator.styl'
import {stripeApi} from '@/api/stripe';
import {squareApi} from '@/api/square';
import InfoPopup from '@/components/common/modals/InfoPopup';
import QuestionPopup from '@/components/common/modals/QuestionPopup'

export default {
    name: 'payment-link-generator',
    data: () => ({
        paymentLink: '',
        productName: '',
        currentPaymentId: '',
        price: '',
        customerName: '',
        customerEmail: '',
        ops: {
          rail: {
            size: '3px',
          },
          bar: {
            size: '3px',
            background: 'rgba(0,0,0,0.1)',
          },
        },
    }),
    methods: {
      moment,
      async generatePaymentLink (paymentSystemAccount) {
        let paymentLinkGenerationMethod = null;
        switch (paymentSystemAccount) {
          case 'FLYFlights':
            paymentLinkGenerationMethod = stripeApi.createFlyFlightsPaymentLinkWithHoldCC;
            break;
          case 'FLYICorp':
            paymentLinkGenerationMethod = stripeApi.createPaymentLinkWithHoldCC;
            break;
          case 'Square':
            paymentLinkGenerationMethod = squareApi.generateCcHoldPaymentLink;
            break;
        }

        const response = await paymentLinkGenerationMethod({
          price: this.price,
          productName: this.productName,
          customerName: this.customerName,
          customerEmail: this.customerEmail,
        })
        if (response.data.isSuccessfull) {
          this.paymentLink = response.data.item
        } else {
          this.paymentLink = response.data.message
        }
      },
      copy (text) {
        navigator.clipboard.writeText(text);
      },
      clear () {
        this.paymentLink = '';
        this.productName = '';
        this.price = '';
        this.customerName = '';
        this.customerEmail = '';
      },
      cancelPaymentClick (paymentId) {
        this.currentPaymentId = paymentId;
        this.$modal.show('QuestionPopupCancel');
      },
      capturePaymentClick (paymentId) {
        this.currentPaymentId = paymentId;
        this.$modal.show('QuestionPopupCapture');
      },
      async capture () {
        const result = await squareApi.capturePayment(this.currentPaymentId);
        console.log(result);
        if (result.data.isSuccessfull) {
          this.showInfoDialog('Payment was captured.');
        } else {
          this.showInfoDialog('Something went wrong: ' + result.data.message);
        }
        await this.$store.dispatch('getUncapturedPayments')
      },
      async cancel () {
        const result = await squareApi.cancelPayment(this.currentPaymentId);
        console.log(result);
        if (result.data.isSuccessfull) {
          this.showInfoDialog('Payment was canceled.');
        } else {
          this.showInfoDialog('Something went wrong: ' + result.data.message);
        }
        await this.$store.dispatch('getUncapturedPayments')
      },
      showInfoDialog (title) {
        this.$modal.show('InfoPopup', { title: title });
      },
    },
    computed: {
      uncapturedPayments () {
        return this.$store.state.payment.uncapturedPayments
      },
    },
    async created () {
      await this.$store.dispatch('getUncapturedPayments')
    },
    components: {
      InfoPopup,
      QuestionPopup,
    },
}
</script>
